/**
 * The ages a learner can be, once (DEC-S2-S02-03, MC-09: "El producto habilita
 * 3–18").
 *
 * Server-owned: the students service enforces this, and the add-a-learner form
 * and the landing page read the same value rather than a mirror of it.
 *
 * The upper bound is DEC-S2-S01-07's: the guardian-linked model holds up to 18
 * inclusive. It is checked when a birth date is written, and nothing acts on a
 * learner turning 18 or passing it: an adult-learner account is a future variant
 * that age never activates, so no identity or authority migrates by itself.
 */
export const LEARNER_AGE_LIMITS = {
  minAge: 3,
  maxAge: 18,
} as const;
